export const screens = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  '2xl': '1600px',
  '3xl': '1920px',
  '4xl': '2560px'
}
